module.exports = {
  themes: {
    getAll: "themes:getAll",
    get: "themes:get",
    create: "themes:create",
    update: "themes:update",
    delete: "themes:delete",
  },
  bowlingCenter: {
    all: "bowlingCenter:all",
    getCenterById: "bowlingCenter:getCenterById",
    getPlayersByBC: "bowlingCenter:getPlayersByBC",
  },
};
